import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from '@shared/models/product.model';
import { ProductSkuFilterRequest } from '@shared/models/request/product-sku-filter-request';
import { ProductsService } from '@shared/services/products.service';

@Component({
  selector: 'app-product-search',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.scss']
})
export class ProductSearchComponent implements OnInit {

  products: Product[]

  keyword: string = ""

  resolverReady: boolean = false

  //Filter
  currentPage: number = 0;
  totalPageNum: number = 0;
  totalElements: number = 0;

  constructor(private route: ActivatedRoute, private router: Router, private productService: ProductsService) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      this.keyword = params.get('keyword')
    })

    this.route.data.subscribe((data: { products: any }) => {

      this.products = data.products.content

      this.currentPage = data.products.number

      this.totalPageNum = data.products.totalPages

      this.totalElements = data.products.totalElements

    })

    this.route.queryParamMap.subscribe(params => {
      if(params.keys.length > 0 && this.resolverReady && this.route.snapshot.params.keyword === this.keyword) {
        const page = parseInt(params.get("page"))

        this.productService.getProductSearchList(page, "id", "12", "DESC", this.keyword, new ProductSkuFilterRequest()).subscribe((data) => {
          this.products = data.content
          this.totalPageNum = data.totalPages
          this.currentPage = page
        })
      }else {
        //if url params is null
        if(!this.resolverReady || this.route.snapshot.params.keyword !== this.keyword) {
          this.resolverReady = true
        }else {
          this.productService.getProductSearchList(0, "id", "12", 'DESC', this.keyword, new ProductSkuFilterRequest()).subscribe((data) => {
            this.products = data.content
            this.totalPageNum = data.totalPages
            this.currentPage = 0
          })
        }
      }
    })
  }

  onPageChange(pageNum: number) {
    this.filterProduct(pageNum)
  }

  filterProduct(page: number) {
    //UPDATE url params
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        page: page
      },
      queryParamsHandling: 'merge',
    });
  }

}
